import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

export interface TransferExpiredPanelProps {
  isReset: boolean
}

export const TransferExpiredPanel = ({ isReset }: TransferExpiredPanelProps) => {
  // Only show the expired message if the NFT has NOT been reset
  // If it's been reset, the transfer should be enabled
  if (isReset) {
    return null
  }

  return (
    <MultilineMessageBox variant="error" icon={<MessageBoxIcon size={"md"} variant="error" />}>
      <BodySM className="text-error-text">
        This veSCALE NFT has expired and you can only transfer an expired NFT that has been reset.
        <br />
        Please reset the NFT first if you want to transfer it.
      </BodySM>
    </MultilineMessageBox>
  )
}
